<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>

    <h3>Thank You</h3>
    <table class="table">
      <thead>
      <tr>
        <th scope="col">Description</th>
        <th scope="col">Amount</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in cart.items" v-bind:key="item.id">
        <td>{{item.description}}</td>
        <td>${{item.amount}}</td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td>Total:</td>
        <td>${{totalPrice}}</td>
      </tr>
      </tfoot>
    </table>

    <p>
      Thank you for using the Cook County Department of Environment &amp; Sustainability on-line permit application
      system. After approval of your permit application by the department, it will be emailed to the address you
      provided with your application.
    </p>
    <dl class="row">
      <dt class="col-12">For Customer Service:</dt>
      <dt class="col-sm-3">Hours:</dt>
      <dd class="col-sm-9">8:30am - 4:30pm</dd>
      <dt class="col-sm-3">Phone:</dt>
      <dd class="col-sm-9">312-603-8200 (and follow appropriate prompt)</dd>
    </dl>
  </div>
</template>

<script>
import { ShoppingCart } from '@/js/FormObjects';

const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

export default {
  name: 'GenericThankYou',
  data() {
    return {
      cart: new ShoppingCart(),
      fetchingData: false,
    };
  },
  mounted() {
    if (this.$store.state.tempForm) {
      this.cart = Object.assign({}, this.$store.state.tempForm);
      this.$store.commit('temporaryForm', null);
    }
  },
  computed: {
    totalPrice() {
      const amounts = this.cart.items.map(i => i.amount);
      if (!amounts || amounts.length === 0) {
        return 0.00;
      }
      return amounts.reduce(sumReducer);
    },
  },
};
</script>
